import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// returns current projectId
export const useProjectId = () => {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const projectIdFromSearch = params.get('projectId');

  const parseProjectId = () => {
    const paths = pathname.split('/').filter(Boolean);
    if (!paths[0] || !(paths[0] === 'projects' || paths[0] === 'my-projects'))
      return undefined;
    // no current project
    if (!paths[1]) return undefined;
    return Number(paths[1]);
  };
  const [projectId, setProjectId] = useState<number | undefined>(
    parseProjectId
  );

  useEffect(() => {
    if (projectIdFromSearch) {
      setProjectId(Number(projectIdFromSearch));
    } else {
      setProjectId(parseProjectId());
    }
  }, [pathname, search]);

  return projectId;
};
